import * as React from "react";
import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";
export default function CondensedToggleButton(_a) {
    var children = _a.children, checked = _a.checked, variant = _a.variant;
    return (React.createElement(RadioGroup.Label, { className: classNames("flex h-12 w-full cursor-pointer items-center leading-none", {
            "justify-center border-gray-200 group-first:rounded-l group-last:rounded-r group-last:border-r-0": variant === "condensed",
        }, {
            "border-r-0 bg-[#F5F8FF] font-bold text-savvy ring-1 ring-savvy": checked && variant === "condensed",
        }, {
            "border-r-[1.5px]": !checked && variant === "condensed",
        }, {
            "justify-start rounded p-4 ring-1 ring-gray-200": variant === "grid",
        }, {
            "bg-[#F5F8FF] font-bold text-savvy ring-1 ring-savvy": checked && variant === "grid",
        }) }, children));
}
